/* ==========================================================================
   Homnio — "Buy Now" button
   Companion to homnio-bundle.js. Deliberately does NOT redefine or subclass
   the <homnio-bundle> custom element: it delegates from the document, then
   reuses that element's own public methods, so the variant + quantity logic
   has exactly one implementation (itemsForSelection) and can never drift from
   Add to Cart.

   Behaviour: add the currently selected offer via the Ajax Cart API, then send
   the customer straight to /checkout. Cart contents are preserved — anything
   already in the cart comes along, which is what a shopper expects.

   Compatible with Online Store 2.0. No dependencies. ES5 syntax to match the
   surrounding theme code.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SEL = '[data-homnio-bundle-buynow]';

  function closest(el, selector) {
    // Element.closest with a guard for text nodes / older Safari.
    if (!el) return null;
    if (el.nodeType !== 1) el = el.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  function setBusy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!on);
    if (on) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-disabled');
    }
  }

  function onClick(evt) {
    var btn = closest(evt.target, SEL);
    if (!btn) return;

    evt.preventDefault();

    var root = closest(btn, 'homnio-bundle');
    // The element must be upgraded (it is by the time a human can click) and
    // must expose the shared selection logic. If not, fail safe to the cart.
    if (!root || typeof root.itemsForSelection !== 'function') {
      window.location.assign(ROOT + 'cart');
      return;
    }

    // Respect the same guards as Add to Cart: no double submits, and no
    // submitting while an offer is unavailable / unselected.
    if (root.submitting) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var items = root.itemsForSelection();
    if (!items.length) {
      if (typeof root.showError === 'function') {
        root.showError(root.dataset.errSelect || 'Please choose an option first.');
      }
      return;
    }

    if (typeof root.clearError === 'function') root.clearError();
    root.submitting = true;
    setBusy(btn, true);

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error((result.data && (result.data.description || result.data.message)) || '');
        }
        // Let the theme's listeners (cart bubble, pixels) see the add before we
        // navigate away. Non-fatal if the pub/sub bus is absent.
        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'homnio-buynow',
              cartData: result.data
            });
          }
        } catch (e) { /* non-fatal */ }

        window.location.assign(ROOT + 'checkout');
        // Stay busy: the page is navigating, so never re-enable the button.
      })
      .catch(function (err) {
        root.submitting = false;
        setBusy(btn, false);
        if (typeof root.showError === 'function') {
          root.showError(
            (err && err.message) ||
              root.dataset.errGeneric ||
              'Sorry, we could not start your checkout. Please try again.'
          );
        }
      });
  }

  document.addEventListener('click', onClick);
})();
